export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  NON_BINARY: 'non-binary',
  PREFER_NOT_TO_SAY: 'prefer not to say',
} as const;

export const GENDER_OPTIONS = [
  { value: GENDER.MALE, label: 'Male' },
  { value: GENDER.FEMALE, label: 'Female' },
  { value: GENDER.NON_BINARY, label: 'Non-binary' },
  { value: GENDER.PREFER_NOT_TO_SAY, label: 'Prefer not to say' },
];
